'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRules$002dPage$0024 from "./presto.-List-Rules-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485 from "./presto.-Presto-Router$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$84() {
  this.bpb = null;
  this.bp3 = null;
  this.bp4 = false;
  this.bpc = null;
  this.bpd = false;
  this.bpg = null;
  this.bp9 = null;
  this.bpa = false;
  this.bp5 = null;
  this.bp6 = false;
  this.bp7 = null;
  this.bp8 = false;
  this.bpe = false;
  this.bpf = false;
  this.bpb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpg = "ListRulesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$84 as $c_Lpresto_PrestoRouter$$anon$84 };
$p = $c_Lpresto_PrestoRouter$$anon$84.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$84;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$84() {
}
export { $h_Lpresto_PrestoRouter$$anon$84 as $h_Lpresto_PrestoRouter$$anon$84 };
$h_Lpresto_PrestoRouter$$anon$84.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bpb;
});
$p.M = (function() {
  if ((!this.bp4)) {
    this.bp3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bp4 = true;
  }
  return this.bp3;
});
$p.O = (function() {
  if ((!this.bpd)) {
    this.bpc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpd = true;
  }
  return this.bpc;
});
$p.D = (function() {
  return this.bpg;
});
$p.t = (function() {
  if ((!this.bpa)) {
    this.bp9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpa = true;
  }
  return this.bp9;
});
$p.N = (function() {
  if ((!this.bp6)) {
    this.bp5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bp6 = true;
  }
  return this.bp5;
});
$p.Q = (function() {
  if ((!this.bp8)) {
    this.bp7 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485.$c_Lpresto_PrestoRouter$$anon$85();
    this.bp8 = true;
  }
  return this.bp7;
});
$p.v = (function() {
  if ((!this.bpf)) {
    this.bpe = false;
    this.bpf = true;
  }
  return this.bpe;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee549) => ((p) => \u03b4scrutinee549))($j_presto$002e$002dList$002dRules$002dPage$0024.$m_Lpresto_ListRulesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$84 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$84, "presto.PrestoRouter$$anon$84", ({
  P1: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$84 as $d_Lpresto_PrestoRouter$$anon$84 };
//# sourceMappingURL=presto.-Presto-Router$$anon$84.js.map
